import PropTypes from 'prop-types';
export default PropTypes.shape({
    name: PropTypes.string.isRequired,
    params: PropTypes.object,
    isFinal: PropTypes.bool
});
